module.exports = __webpack_public_path__ + "static/assets/ddae2f39a0d6a932cc13b73a3464aaa5.png";